import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../pipes/translate.pipe';

export interface GalleryImage {
  url: string;
  title?: string;
  description?: string;
}

@Component({
  selector: 'app-image-gallery',
  standalone: true,
    imports: [CommonModule, TranslatePipe],
  template: `
    <div class="mb-8 rounded-xl overflow-hidden bg-gradient-to-br from-green-50 to-emerald-50 dark:from-slate-800 dark:to-slate-900 p-6 shadow-xl">
      <h3 class="text-2xl font-bold text-slate-900 dark:text-slate-100 mb-4">{{ title() || ('common.gallery' | translate) }}</h3>
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        @for (image of images(); track image.url) {
          <div class="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
            <div class="aspect-video w-full bg-slate-200 dark:bg-slate-700 relative overflow-hidden">
              <img 
                [src]="image.url" 
                [alt]="image.title || ('accessibility.galleryImage' | translate)"
                class="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                loading="lazy"
              />
              <!-- Overlay with info -->
              @if (image.title || image.description) {
                <div class="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
                  @if (image.title) {
                    <h4 class="text-white font-bold text-lg">{{ image.title }}</h4>
                  }
                  @if (image.description) {
                    <p class="text-white/90 text-sm mt-1">{{ image.description }}</p>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageGalleryComponent {
  title = input<string>('');
  images = input<GalleryImage[]>([]);
}
